module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.BRFNoFilter ||
        _vm.Filter.EnqNoFilter ||
        _vm.Filter.agentFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineFilter ||
        _vm.Filter.TransportTypeFilter ||
        _vm.Filter.ShipemntTypeFilter ||
        _vm.Filter.billingTypeFilter ||
        _vm.Filter.billingForFilter ||
        _vm.Filter.CSTeamFilter ||
        _vm.Filter.contractNoFilter ||
        _vm.Filter.fk_ccbm_id ||
        _vm.Filter.commodityHsnCodeFilter ||
        _vm.Filter.EMPFilter ||
        _vm.Filter.PORFilter ||
        _vm.Filter.POLFilter ||
        _vm.Filter.PODFilter ||
        _vm.Filter.FPODFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.updatedByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.createdAtRange.startDate ||
        _vm.Filter.createdAtRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.BRFNoFilter ||
    _vm.Filter.EnqNoFilter ||
    _vm.Filter.agentFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineFilter ||
    _vm.Filter.TransportTypeFilter ||
    _vm.Filter.ShipemntTypeFilter ||
    _vm.Filter.billingTypeFilter ||
    _vm.Filter.billingForFilter ||
    _vm.Filter.CSTeamFilter ||
    _vm.Filter.contractNoFilter ||
    _vm.Filter.fk_ccbm_id ||
    _vm.Filter.commodityHsnCodeFilter ||
    _vm.Filter.EMPFilter ||
    _vm.Filter.PORFilter ||
    _vm.Filter.POLFilter ||
    _vm.Filter.PODFilter ||
    _vm.Filter.FPODFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.updatedByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.createdAtRange.startDate ||
    _vm.Filter.createdAtRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getBookingResp.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getBookingResp', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  })], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdAtRange", $$v)
      },
      expression: "Filter.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("BRF NO Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search BRF NO Filter",
      "id": "BRFNoFilter",
      "name": "BRFNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.BRFNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "BRFNoFilter", $$v)
      },
      expression: "Filter.BRFNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Enq No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Enq No Filter",
      "id": "EnqNoFilter",
      "name": "EnqNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.EnqNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "EnqNoFilter", $$v)
      },
      expression: "Filter.EnqNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.TransportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "TransportTypeFilter", $$v)
      },
      expression: "Filter.TransportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "value",
      "option-text": "value",
      "placeholder": "Select Shipment Type"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ShipemntTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ShipemntTypeFilter", $$v)
      },
      expression: "Filter.ShipemntTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "pTypeVal",
      "option-text": "pTypeText",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.statusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "statusFilter", $$v)
      },
      expression: "Filter.statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Billing Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BillingTypeList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Type"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.billingTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "billingTypeFilter", $$v)
      },
      expression: "Filter.billingTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineFilter", $$v)
      },
      expression: "Filter.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "id": "agentFilter",
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent Name"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.agentFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "agentFilter", $$v)
      },
      expression: "Filter.agentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("RA Number")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContractList'],
      "id": "contractNoFilter",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getContractNoBasedVessel(_vm.Filter.contractNoFilter);
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.contractNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "contractNoFilter", $$v)
      },
      expression: "Filter.contractNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Vessel Name :")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllContractBasedVesselList'],
      "id": "vessel_name",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vessel Name"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.fk_ccbm_id),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "fk_ccbm_id", $$v)
      },
      expression: "Filter.fk_ccbm_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("EMPTY PICK UP")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.TransportTypeFilter == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.Filter.TransportTypeFilter == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
        ],
      "id": "EMPFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.EMPFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "EMPFilter", $$v)
      },
      expression: "Filter.EMPFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.TransportTypeFilter == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.Filter.TransportTypeFilter == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPORDDList'
        ],
      "id": "PORFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PORFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PORFilter", $$v)
      },
      expression: "Filter.PORFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.TransportTypeFilter == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.Filter.TransportTypeFilter == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPOLDDList'
        ],
      "id": "POLFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.POLFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POLFilter", $$v)
      },
      expression: "Filter.POLFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.TransportTypeFilter == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.Filter.TransportTypeFilter == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
        ],
      "id": "PODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.PODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "PODFilter", $$v)
      },
      expression: "Filter.PODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("FPOD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.Filter.TransportTypeFilter == 'CRC' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineCrossCountryDDList'
        ] :
        _vm.Filter.TransportTypeFilter == 'EXPORT' ?
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
        ] :
        _vm.$store.getters[
          'enqPriceEngineDropdown/getAllEnqPriceEngineIMPPODDDList'
        ],
      "id": "FPODFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.FPODFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPODFilter", $$v)
      },
      expression: "Filter.FPODFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" CS Team/Sales Person ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "CSTeamFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select CS Team/Sales Person"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.CSTeamFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "CSTeamFilter", $$v)
      },
      expression: "Filter.CSTeamFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Updated By User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "updatedByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Cleared User"
    },
    on: {
      "input": function($event) {
        _vm.getBookingRespDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.updatedByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "updatedByFilter", $$v)
      },
      expression: "Filter.updatedByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getBookingResp,
      "fields": _vm.BookingResponseFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "BookingNo",
      fn: function(row1) {
        return [_c('strong', [_vm._v("BRF No:")]), _vm._v(_vm._s(row1.item.BookingNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("BRF Date:")]), _vm._v(" " + _vm._s(row1.item.JobDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Enq No:")]), _vm._v(_vm._s(row1.item.EnquiryNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Enq Pricing No:")]), _vm._v(_vm._s(row1.item.EnqPricingNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Client Name:")]), _vm._v(" " + _vm._s(row1.item.ClientName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Shipping Line:")]), _vm._v(" " + _vm._s(row1.item.ShippingLine)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Transport Type:")]), _vm._v(" " + _vm._s(row1.item.TransportType)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Shipemnt Type:")]), _vm._v(" " + _vm._s(row1.item.ShipemntType)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Billing Type:")]), _vm._v(" " + _vm._s(row1.item.BillingType)), _c('br')]
      }
    }, {
      key: "EmptyPickup",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Empty Pickup:")]), _vm._v(" " + _vm._s(row1.item.EmptyPickup)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row1.item.Por)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row1.item.Pol)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row1.item.Pod)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row1.item.Fpod)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Humidity:")]), _vm._v(" " + _vm._s(row1.item.Humidity)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cargo Weight:")]), _vm._v(" " + _vm._s(row1.item.CargoWeight)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Spot NonSpot:")]), _vm._v(" " + _vm._s(row1.item.SpotNonSpot)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Ra Number:")]), _vm._v(" " + _vm._s(row1.item.RaNumber)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Rate Agreed:")]), _vm._v(" " + _vm._s(row1.item.RateAgreed)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("SI CUT OFF:")]), _vm._v(" " + _vm._s(row1.item.SiCutOfDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("FREIGHT TERMS ( MBL):")]), _vm._v(" " + _vm._s(row1.item.FreightTermsMbl)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("FREIGHT TERMS HBL:")]), _vm._v(" " + _vm._s(row1.item.FreightTermsHbl)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("DESTINATION CHARGES:")]), _vm._v(" " + _vm._s(row1.item.DestinationCharges)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("DESTINATION CHARGES Det.:")]), _vm._v(" " + _vm._s(row1.item.DestinationChargesDet)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("FIRST MILE BOOKING:")]), _vm._v(" " + _vm._s(row1.item.FirstMileBooking)), _c('br')]
      }
    }, {
      key: "CommodityItemName",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Commodity Item Name:")]), _vm._v(" " + _vm._s(row1.item.CommodityItemName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Commodity Hsn Code:")]), _vm._v(" " + _vm._s(row1.item.CommodityHsnCode)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Commodity Item HsnCode:")]), _vm._v("\n                " + _vm._s(row1.item.CommodityItemHsnCode)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Agent Type:")]), _vm._v(" " + _vm._s(row1.item.AgentCategoryType)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Agent Name:")]), _vm._v(" " + _vm._s(row1.item.AgentName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Container Type:")]), _vm._v(" " + _vm._s(row1.item.continerTypeDet)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Tues Count:")]), _vm._v(" " + _vm._s(row1.item.TuesCount)), _c('br')]
      }
    }, {
      key: "HandoverDate",
      fn: function(row1) {
        return [_c('strong', [_vm._v("ETD:")]), _vm._v(" " + _vm._s(row1.item.Etd)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Handover Date:")]), _vm._v(" " + _vm._s(row1.item.HandoverDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Valid For Sail:")]), _vm._v(" " + _vm._s(row1.item.ValidForSail)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Valid Till:")]), _vm._v(" " + _vm._s(row1.item.ValidTill)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Country Name:")]), _vm._v(" " + _vm._s(row1.item.CurrencyCountryName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Currency Name:")]), _vm._v(" " + _vm._s(row1.item.MasterCurrencyCode)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Delivery Mode:")]), _vm._v(" " + _vm._s(row1.item.DeliveryMode)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Quotation Till:")]), _vm._v(" " + _vm._s(row1.item.QuotationTillStatus)), _c('br')]
      }
    }, {
      key: "IsUsed",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Temperature Required:")]), _vm._v(" " + _vm._s(row1.item.TemperatureRequired)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Un Number:")]), _vm._v(" " + _vm._s(row1.item.UnNumber)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Imdg Class:")]), _vm._v(" " + _vm._s(row1.item.ImdgClass)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Packing Code:")]), _vm._v(" " + _vm._s(row1.item.PackingCode)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Other Commodity:")]), _vm._v(" " + _vm._s(row1.item.OtherCommodity)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Commodity Type:")]), _vm._v(" " + _vm._s(row1.item.CommodityType)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Inco Term:")]), _vm._v(" " + _vm._s(row1.item.IncoTerm)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Bl Instruction:")]), _vm._v(" " + _vm._s(row1.item.BlInstruction)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("PDA:")]), _vm._v(" " + _vm._s(row1.item.Pda)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Free Days:")]), _vm._v(" " + _vm._s(row1.item.FreeDays)), _c('br')]
      }
    }, {
      key: "CreatedAt",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Created By:")]), _vm._v(" " + _vm._s(row1.item.CreatedByUser)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Created Date:")]), _vm._v(" " + _vm._s(row1.item.CreatedAt)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Updated By:")]), _vm._v(" " + _vm._s(row1.item.UpdatedByUser)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Updated Date:")]), _vm._v(" " + _vm._s(row1.item.UpdatedAt)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row1.item.RaisedFrom)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Remarks:")]), _vm._v(" " + _vm._s(row1.item.Remarks)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Is Used:")]), _vm._v(" " + _vm._s(row1.item.IsUsed)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Is Active:")]), _vm._v(" " + _vm._s(row1.item.IsActive)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Is Deleted:")]), _vm._v(" " + _vm._s(row1.item.IsDeleted)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Is Enq Pricing Closed:")]), _vm._v(" " + _vm._s(row1.item.IsEnqPricingClosed)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Is Enq Pricing Used:")]), _vm._v(" " + _vm._s(row1.item.IsEnqPricingUsed)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Is Enq Pricing Active:")]), _vm._v(" " + _vm._s(row1.item.IsEnqPricingActive)), _c('br'), _vm._v(" "), (_vm.$route.path == '/booking-resp-list') ? _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "xxl",
            "disabled": _vm.isSubmited,
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              _vm.DuplicateBookingResp(row1.item, 'edit')
            }
          }
        }, [(_vm.isSubmited) ? _c('md-spinner', {
          staticStyle: {
            "width": "20px",
            "height": "20px"
          },
          attrs: {
            "md-indeterminate": ""
          }
        }) : _vm._e(), _vm._v("\n                  Edit BRF\n\n                ")], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path == '/booking-resp-list') ? _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "xxl",
            "disabled": _vm.isSubmited,
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              _vm.DuplicateBookingResp(row1.item, 'duplicate')
            }
          }
        }, [(_vm.isSubmited) ? _c('md-spinner', {
          staticStyle: {
            "width": "20px",
            "height": "20px"
          },
          attrs: {
            "md-indeterminate": ""
          }
        }) : _vm._e(), _vm._v("\n                  Duplicate BRF\n\n                ")], 1) : _vm._e(), _vm._v(" "), (row1.item.prbr_id > 0 && row1.item.booking_id > 0) ? _c('ToggleBRFSwitch', {
          attrs: {
            "brf_no": row1.item.BookingNo,
            "booking_no": row1.item.ConsoleBookingNo,
            "booking_id": row1.item.booking_id,
            "prbr_id": row1.item.prbr_id,
            "isbookingactive": row1.item.isbookingactive,
            "prbr_is_active": row1.item.prbr_is_active,
            "request_type": 'BRF'
          },
          on: {
            "success": _vm.getBookingRespDash
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.prbr_id > 0) ? _c('BRFCard', {
          attrs: {
            "BRFDetails": row1.item,
            "prbr_id": Number(row1.item.prbr_id)
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d49f6730","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pricing/bookingRespDash.vue
// module id = 2869
// module chunks = 0